let _components = {};

export default class Component {
    constructor(element) {
        this.element = element;
        _components[element] = this;
    }

    static parse(selector, componentClass) {
        let ret = [];
        for (let element of document.querySelectorAll(selector)) {
            ret.push(new componentClass(element));
        }
        return ret;
    }

    static getComponent(element) {
        if (typeof element === "string") {
            element = document.querySelector(element);
        }

        if (element === null) return;

        return _components.hasOwnProperty(element) ? _components[element] : null;
    }
}

window.getUIComponent = Component.getComponent;


// WEBPACK FOOTER //
// ./src/components/Component.js